import resource from 'resource-axios'
import axios from 'axios'

const _base = 'rpc/'
const customActions = {
	signup: (payload) =>
		axios.post(`${_base}signup`, payload)
}
export const clients = resource('/rpc/signup', customActions, axios)

